module.exports = __webpack_public_path__ + "img/logo-slogan-en.01c7a10c.png";